import React, { useEffect, useState } from 'react'
import Back from '../../../../components/back'
import { useParams } from 'react-router-dom'
import useRequest from '../../../../components/hooks/use-request'
import RolePrivileges from './role-privileges'
import AddPrivileges from './add-privilege'

const RoleDetails = () => {
  const [data, setData] = useState<any>([]);
  const [privileges, setPrivileges] = useState([]);
  const { id } = useParams<{ id: string }>();

  const { makeRequest: getRoles, loading } = useRequest(`/roles/${id}`, "GET");

  

  useEffect(() => {
    const fetchData = async () => {
      const [response] = await getRoles();
      setData(response?.data?.role || [])
      setPrivileges(response?.data?.role?.privileges || []);
    };
    fetchData();
  }, []);

  return (
    <>
      <div className="flex gap-5 mt-5">
        <Back />
        <h2 className="text-[24px] font-bold">Role Details</h2>
      </div>
      <div className='flex justify-between gap-10'>
          <AddPrivileges details = {data}/>
          <RolePrivileges data = {privileges} loading = {loading}/>
      </div>
    </>
  )
}

export default RoleDetails